import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui'
import i18n from './i18n' // 国际化
import FloatingContactButtons from './components/chat/FloatingContactButtons.vue' // 悬浮按钮
import './assets/styles/global.less'
import 'element-ui/lib/theme-chalk/index.css'
import './icons' // icon
import VueQrcode from 'vue-qrcode';
import { parseTime,resetForm,addDateRange,handleTree } from "@/utils/tools";
import Pagination from "@/components/Pagination";// 分页组件

Vue.prototype.parseTime = parseTime
Vue.prototype.resetForm = resetForm
Vue.prototype.addDateRange = addDateRange
Vue.prototype.handleTree = handleTree

Vue.use(ElementUI)
Vue.config.productionTip = false
Vue.component('FloatingContactButtons', FloatingContactButtons)
Vue.component('qrcode', VueQrcode);
Vue.component('Pagination', Pagination)

new Vue({
  i18n,
  router,
  store,
  render: h => h(App)
}).$mount('#app') 